<template>
  <div id="app">
    <PageHeader />
    <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link :to="{ name: 'product', params: {id: 'b6b83e3428b94451b0001a4eb0ca622c' } }">Testprodukt</router-link>

    </div>
    <router-view/>
  </div>
</template>

<style lang="sass">
  @import 'normalize-scss'
  @include normalize()
  #app
    font-family: $font
    -webkit-font-smoothing: antialiased
    -moz-osx-font-smoothing: grayscale
</style>

<script>
import PageHeader from '@/components/organisms/PageHeader'
import { mapState, mapActions } from 'vuex'

export default {
  components: { PageHeader },
  methods: {
    ...mapActions('categories', [
      'fetchItems'
    ])
  },
  created () {
    this.fetchItems()
  }
}

</script>
